import { render, staticRenderFns } from "./AddObjectSummary.vue?vue&type=template&id=a50fb5da&"
import script from "./AddObjectSummary.vue?vue&type=script&lang=js&"
export * from "./AddObjectSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports